import React from 'react'
import { getEnvironmentConfig } from '../../../utils/detectEnv'
import { useAppSelector } from '../../../store/hooks'

// SCAL's regionCd, per the TORTOWNER.EMPLOYEE region reference (CHAR(1); B = Southern California).
const SCAL_REGION_CD = 'B'

const ApproverResources: React.FC = () => {
  const envConfig = getEnvironmentConfig() as any
  const tortSharePointUrl = envConfig.TortSharePointUrl || ''
  const tortTrainingUrl = envConfig.TortKpLearnUrl || ''
  const timeOffPoliciesUrl = envConfig.TimeOffPoliciesUrl || ''
  const regionCd = useAppSelector((state) => state.profile?.data?.employee?.regionCd)
  const isScalUser = (regionCd || '').trim().toUpperCase() === SCAL_REGION_CD

  const helpfulResources = [
    { id: 'approver-proxy-form', label: 'Approver Proxy Add/Remove Form ', link: '/assets/documents/approver-proxy-add-remove-form.docx', hasDoc: true },
    { id: 'float-employees-form', label: 'Float Employees Add/Remove Form', link: '/assets/documents/float-employees-add-remove-form.docx', hasDoc: true },
    { id: 'tort-sharepoint', label: 'TORT SharePoint site', link: tortSharePointUrl, hasDoc: false },
    { id: 'tort-kplearn', label: 'Take KpLearn Approver TORT training', link: tortTrainingUrl, hasDoc: false },
    { id: 'tort-jobAid', label: 'Review TORT Approver Job Aid', link: '/assets/documents/tort-approver-job-aid.pdf', hasDoc: false },
    { id: 'view-faqs', label: 'Questions? View FAQs', link: '/assets/documents/tort-employee-faq.pdf', hasDoc: false },
    ...(isScalUser ? [{ id: 'super-user-list', label: 'SCAL Super User contact list', link: '/assets/documents/scal-super-user-contact-list.xls', hasDoc: false }] : []),
    { id: 'time-policies', label: 'Review Time Off Policies', link: timeOffPoliciesUrl, hasDoc: false },
    { id: 'my-request', label: 'My Time Off Request', link: '/requestor', hasDoc: false },
  ]

  const getBadgeText = (resource: typeof helpfulResources[0]): string => {
    if (resource.label.includes('Job Aid')) return '[pdf]'
    if (resource.hasDoc) return '[DOC]'
    return ''
  }

  return (
    <div className="mt-12 mb-8 !py-[40px]">
      <div className="grid grid-cols-1 desktop:grid-cols-2 gap-6 items-start">
        {/* Helpful Resources Box */}
        <div className="border border-[#D9E2EC] rounded-lg !px-[24px] !py-[24px] bg-white">
          <h2 className="h2 mb-4">Helpful Resources</h2>
          <ul className="list-disc pl-5 ml-4! marker:text-[#0074AD]">
            {helpfulResources.map((resource) => (
              <li key={resource.id} className="text-base mt-2!">
                {resource.link ? (
                  <a
                    href={resource.link}
                    {...(resource.id !== 'my-request' && {
                      target: '_blank',
                      rel: 'noopener noreferrer',
                    })}
                    className="text-[#0074AD] underline"
                  >
                    {resource.label}
                    {resource.hasDoc && (
                      <span className="text-base text-[#0074AD]">
                        {' '}
                        {getBadgeText(resource)}
                      </span>
                    )}
                  </a>
                ) : (
                  <span className="text-[#0074AD]">
                    {resource.label}
                    {resource.hasDoc && (
                      <span className="text-base text-[#0074AD]">
                        {' '}
                        {getBadgeText(resource)}
                      </span>
                    )}
                  </span>
                )}
              </li>
            ))}
          </ul>
        </div>

        {/* Questions Box */}
        <div className="border border-[#D9E2EC] rounded-lg !px-[24px] !py-[24px] bg-white">
          <h2 className="h2 mb-4">Questions?</h2>
          <p className="p3 -book text-xs mt-4">
              Please follow up with the TORT authorized approver for general
              TORT questions. For escalated TORT issues, please contact the
              National TORT Support team at{' '}
              <a href="mailto:NAT-TORT@kp.org" className="whitespace-nowrap text-[#0074AD]">
                NAT-TORT@kp.org
              </a>
              {' '}
              Please include your name, employee ID, NUID, computer screenshots,
              and a description of your issue.
            </p>
          <div style={{ height: '2rem', display: 'block' }} />
          <p className="text-base font-[325] leading-6 text-gray-700 pl-6">
            To update the KP TIME Primary Approver please have a manager contact the KP TIME system at{' '}
            <a
              href="mailto:NPS-National-Timekeeping@kp.org"
              className="text-[#0074AD] underline"
            >
              NPS-National-Timekeeping@kp.org
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}

export default ApproverResources
